import { render, staticRenderFns } from "./LocalizationSelector.vue?vue&type=template&id=3ac012e9&"
import script from "./LocalizationSelector.vue?vue&type=script&lang=js&"
export * from "./LocalizationSelector.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationSelector.vue?vue&type=style&index=0&id=3ac012e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports